export type TWalletMutation = {
  CONNECTED_WALLET_TYPE: string
  SDK_STATUS: string
  URI: string
  ADDRESS: string
  LAST_WALLET: string
}

export const NEO_WALLET_MUTATION = {
  CONNECTED_WALLET_TYPE: 'N3_POPULATE_CONNECTED_WALLET_TYPE',
  SDK_STATUS: 'N3_POPULATE_SDK_STATUS',
  URI: 'N3_POPULATE_URI',
  ADDRESS: 'N3_POPULATE_ADDRESS',
  LAST_WALLET: 'N3_POPULATE_LAST_WALLET_CONNECTED',
}

export const X_WALLET_MUTATION = {
  CONNECTED_WALLET_TYPE: 'X_POPULATE_CONNECTED_WALLET_TYPE',
  SDK_STATUS: 'X_POPULATE_SDK_STATUS',
  URI: 'X_POPULATE_URI',
  ADDRESS: 'X_POPULATE_ADDRESS',
  LAST_WALLET: 'X_POPULATE_LAST_WALLET_CONNECTED',
}
